import { GenericGraph, BaseProcessMetadata, Metadata, BaseProcess, Connection, BaseState } from '@common/types';
import { Change } from '@common/types/messageTypes';
import { Store } from 'redux';

import { getProcessPropertyPath, resolveBindingPath } from '../../Parser/bindings';
import { LSP } from './types';

let lastRequestId: string | null = null;

export function getLastRequestId() {
  return lastRequestId;
}

export function getRequestId() {
  lastRequestId = `${Math.random()}`;
  return lastRequestId;
}

export function isLSPError(e: unknown): e is LSP.Error {
  return typeof e === 'object' && e !== null && 'message' in e;
}

export function getDidChangePayload<
  T extends GenericGraph<unknown, BaseProcessMetadata, BaseProcess<BaseProcessMetadata>, Connection>
>(store: Store<BaseState<T, Metadata>>, params: { changes: Change[] }): Change[] {
  const state = store.getState();
  return params.changes.map(({ property, value }) => {
    const requestId = getRequestId();

    property = resolveBindingPath(property, state.graphPath, state.currentComponentId);
    return {
      requestId,
      type: 'partial',
      property,
      value,
      graphPath: getProcessPropertyPath(state)
    };
  });
}

export function dispatchDidChange<
  T extends GenericGraph<unknown, BaseProcessMetadata, BaseProcess<BaseProcessMetadata>, Connection>
>(store: Store<BaseState<T, Metadata>>, changes: Change[]) {
  store.dispatch({ type: LSP.Method.propertiesDidChange, payload: changes });
}
